class QuillSessionStorage {
  private static instance: QuillSessionStorage;

  static getInstance(): QuillSessionStorage {
    if (!QuillSessionStorage.instance) QuillSessionStorage.instance = new QuillSessionStorage();
    return QuillSessionStorage.instance;
  }

  set(name: string, value: string): void {
    if (typeof process.browser === 'undefined') return;

    try {
      sessionStorage.setItem(name, value);
    } catch (e) {
      console.error(e);
    }
  }

  get(name: string): string | null {
    if (typeof process.browser === 'undefined') return null;

    return sessionStorage.getItem(name);
  }
}

export default QuillSessionStorage;
export { QuillSessionStorage };
